<template>
  <div>
    <div class="bg-selling">
      <v-img
        class="imgBgSelling"
        :src="imgUrl('bg-selling.jpg')"
        :aspect-ratio="3.46"
      >
      <template slot="default">
      <div class="topic">{{type === typeBgc ? bbcPage : website}}</div>
      </template>
      </v-img>
    </div>
    <div class="ct-selling">
      <v-row class="pt-16 pa-3" no-gutters justify="center">
        <v-btn-toggle
          v-model="type"
          mandatory
          class="rounded-lg"
        >
          <v-btn>
            <icon :name="type === typeWeb ? 'selling-web-white' : 'selling-web-black'" height="48" width="50" class="mr-4"/>
            <translate>Need a new website?</translate>
          </v-btn>
          <v-btn>
            <icon :name="type === typeWeb ? 'selling-bgc-black' : 'selling-bgc-white'" height="48" width="50" class="mr-4"/>
            <translate class="textCustom">Need managing your BGC page?</translate>
          </v-btn>
        </v-btn-toggle>
      </v-row>
      <v-row class="" no-gutters justify="center" v-if="type === typeWeb">
        <Website @openDialog="openDialog"/>
      </v-row>
      <v-row class="" no-gutters justify="center" v-else>
        <BGC @openDialog="openDialog"/>
      </v-row>
      <ContactForm v-if="open" ref="contact" :pickupData="pickupData"/>
    </div>
  </div>
</template>
<script>
import BGC from "@/components/Selling/BGC";
import ContactForm from "@/components/Contact/ContactForm";
import Website from "@/components/Selling/Website";
export default {
  name: 'Selling',
  components: {BGC, ContactForm, Website},
  data() {
    return {
      type: 0,
      typeWeb: 0,
      typeBgc: 1,
      website: this.$gettext('Never be so easy! Choose the template that match your requirement and budget'),
      bbcPage: this.$gettext('Build a solid and exponential community of Golfers on your BGC Page!'),
      open: false,
      pickupData: {}
    }
  },
  methods: {
    openDialog(data) {
      this.pickupData = data
      this.open = true
      if(this.$refs.contact) {
        this.$refs.contact.open()
      }
    },
  }
}
</script>

